import { useMutation } from "react-query";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import type { RemoteApiError } from "../useRemote/types";
import {
  resendVisitorConsentLinkForPlaceBooking,
  resendVisitorConsentLinkForVisitorRegistration,
  type IssuedVisitorConsentTokenResponse
} from "./visit-consent-token-resend.api";

export type ResendVisitorConsentLinkTarget =
  | { kind: "place"; placeBookingId: number }
  | { kind: "registration"; visitorRegistrationId: number };

export function useRemoteResendVisitorConsentLink() {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation<
    IssuedVisitorConsentTokenResponse,
    RemoteApiError,
    ResendVisitorConsentLinkTarget
  >(
    async target => {
      if (target.kind === "place") {
        const { data } = await resendVisitorConsentLinkForPlaceBooking(target.placeBookingId);
        return data;
      }
      const { data } = await resendVisitorConsentLinkForVisitorRegistration(
        target.visitorRegistrationId
      );
      return data;
    },
    {
      onSuccess: () => {
        enqueueSnackbar(t("_visitorBookings_consentLink_sendSuccess"), { variant: "success" });
      },
      onError: () => {
        enqueueSnackbar(t("_visitorBookings_consentLink_sendError"), { variant: "error" });
      }
    }
  );
}
